import l from "./index437.mjs";
import { css as f, keyframes as u } from "./index438.mjs";
import { default as p } from "./index439.mjs";
import { default as x } from "./index440.mjs";
import { T as g } from "./index441.mjs";
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function y(e, o) {
  const r = l(e, o);
  return process.env.NODE_ENV !== "production" ? (...t) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return t.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : t.some((n) => n === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), r(...t);
  } : r;
}
const a = (e, o) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = o(e.__emotion_styles));
};
export {
  x as GlobalStyles,
  p as StyledEngineProvider,
  g as ThemeContext,
  f as css,
  y as default,
  a as internal_processStyles,
  u as keyframes
};
